/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");
    const firstName = document.querySelector("#first_name");
    if (firstName && firstName.value) {
        firstName.disabled = true;
    }

    const lastName = document.querySelector("#last_name");
    if (lastName && lastName.value) {
        lastName.disabled = true;
    }
    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // custom code goes here
    return claim;
}
